import { apiSlice } from "./apiSlice";

export const notificationApiSlice = apiSlice.injectEndpoints({
  tagTypes: [
    "NotificationCount",
    "NotificationList",
    "NotificationDetail",
  ],
  endpoints: (builder) => ({
    getUnreadCount: builder.query({
      query: () => "/notification/api/v1/unread-count",
      providesTags: ["NotificationCount"],
    }),
    getNotificationList: builder.query({
      query: ({ category, page = 0, size = 10 }) =>
        `/notification/api/v1/list?category=${category}&page=${page}&size=${size}`,
      providesTags: (result, error, arg) => [
        { type: "NotificationList", id: arg.category },
      ],
    }),
    getNotificationDetail: builder.query({
      query: (id) => `/notification/api/v1/${id}`,
      providesTags: (result, error, id) => [
        { type: "NotificationDetail", id },
      ],
    }),
    markAsRead: builder.mutation({
      query: (id) => ({
        url: `/notification/api/v1/read/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["NotificationCount", "NotificationList"],
    }),
    markAllAsRead: builder.mutation({
      query: (category) => ({
        url: `/notification/api/v1/read-all?category=${category}`,
        method: "PUT",
      }),
      invalidatesTags: ["NotificationCount", "NotificationList"],
    }),
    deleteNotification: builder.mutation({
      query: (id) => ({
        url: `/notification/api/v1/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["NotificationCount", "NotificationList"],
    }),
    pinNotification: builder.mutation({
      query: (id) => ({
        url: `/notification/api/v1/pin/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["NotificationList"],
    }),
  }),
});

export const {
  useGetUnreadCountQuery,
  useLazyGetUnreadCountQuery,
  useGetNotificationListQuery,
  useLazyGetNotificationListQuery,
  useGetNotificationDetailQuery,
  useLazyGetNotificationDetailQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
  usePinNotificationMutation,
} = notificationApiSlice;
